import { Model, attr, belongsTo } from '@elatonsev/js-models';
import TubeLineModel from './TubeLineModel';

export default class TubeStationModel extends Model {
  name = attr('string');
  tube_line = belongsTo(TubeLineModel);
}